<template>
  <div class="add-address">
    <Title text="修改地址" />
    <div class="edit-address">
      <van-address-edit
        :area-list="areaList"
        :show-delete="deleteFlag"
        show-set-default
        :address-info="addressInfo"
        show-search-result
        :search-result="searchResult"
        @change-area="onChangeArea"
        @save="onSave"
        @change-default="onChangeDefault"
        @delete="onDelete"
      />
    </div>
  </div>
</template>

<script>
import AreaList from "../../common/area";
import Title from "../../components/Title";
import { EditAddress, AddressDetail, DeleteAddress } from "../../request/api";
export default {
  name: "add-address",
  data() {
    return {
      areaList: AreaList,
      searchResult: [],
      deleteFlag: false,
      areaValues: [],
      defaultFlag: false,
      addressInfo: {}
    };
  },
  components: {
    Title
  },
  created() {
    this.getAddress();
  },
  methods: {
    //地区
    onChangeArea(values) {
      this.areaValues = values;
    },
    //默认地址
    onChangeDefault(value) {
      this.defaultFlag = value;
    },
    //获取单条地址详情
    getAddress() {
      let id = this.$route.params.id;
      if (id) {
        this.deleteFlag = true;
        AddressDetail(id).then(res => {
          let info = res.data;
          this.addressInfo = {
            name: info.receiver,
            tel: info.phone,
            addressDetail: info.address,
            isDefault: info.defaultFlag,
            province: info.provinceCode,
            city: info.cityCode,
            county: info.areaCode,
            areaCode: info.areaCode
          };
        });
      }
    },
    //保存修改地址地址
    onSave(content) {
      let areaValues = this.areaValues;
      let addressInfo = this.addressInfo;
      let id = this.$route.params.id;
      let obj = {
        receiver: content.name,
        phone: content.tel,
        address: content.addressDetail,
        defaultFlag: this.defaultFlag,
        provinceCode: "",
        cityCode: "",
        areaCode: ""
      };
      if (areaValues.length > 1) {
        obj.provinceCode = areaValues[0].code;
        obj.cityCode = areaValues[1].code;
        obj.areaCode = areaValues[2].code;
      } else {
        obj.provinceCode = addressInfo.province;
        obj.cityCode = addressInfo.city;
        obj.areaCode = addressInfo.county;
      }
      EditAddress(id, obj).then(res => {
        if (res.status == 200) {
          this.$toast.success({
            message: "修改成功",
            duration: 700
          });
          this.$router.push("/address");
        }
      });
    },
    // 删除地址
    onDelete(content) {
      let id = this.$route.params.id;
      DeleteAddress(id).then(res=>{
        if(res.status == 200){
          this.$toast.success({
            message: "删除成功",
            duration: 700
          });
          this.$router.push("/address");
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.add-address {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
</style>